import * as React from "react";
import * as ReactDOM from "react-dom";
import { Link } from "react-router-dom";

import {
  AppBar,
  AppBarSection,
  AppBarSpacer,
} from "@progress/kendo-react-layout";
function Header() {
  return (
    <React.Fragment>
      <AppBar>
        <AppBarSection>
          <button className="k-button k-button-clear">
            <span className="k-icon k-i-menu" />
          </button>
        </AppBarSection>

        <AppBarSpacer
          style={{
            width: 4,
          }}
        />

        <AppBarSection>
          <h1 className="title">Sarai React App</h1>
        </AppBarSection>

        <AppBarSpacer
          style={{
            width: 32,
          }}
        />

        <AppBarSection>
          <ul>
            <li>
              <span>
                <Link to="/" className="navLinks">
                  Home
                </Link>
              </span>
            </li>
            <li>
              <span>
                <Link to="/guides" className="navLinks">
                  Guides
                </Link>
              </span>
            </li>
            <li>
              <span>
                <Link to="/medics" className="navLinks">
                  Medics
                </Link>
              </span>
            </li>
            <li>
              <span>
                <Link to="/facilities" className="navLinks">
                  Facilities
                </Link>
              </span>
            </li>
            <li>
              <span>
                <Link to="/videos" className="navLinks">
                  Videos
                </Link>
              </span>
            </li>
            <li>
              <span>
                <Link to="/kits" className="navLinks">
                  Kits
                </Link>
              </span>
            </li>
            <li>
              <span>
                <Link to="/ambulance" className="navLinks">
                  Ambulance & Emergency
                </Link>
              </span>
            </li>
          </ul>
        </AppBarSection>
      </AppBar>
      <style>{`
                body {
                    background: #ffffff;
                }
                .title {
                    font-size: 18px;
                    margin: 0;
                }
                ul {
                    font-size: 14px;
                    list-style-type: none;
                    padding: 0;
                    margin: 0;
                    display: flex;
                }
                li {
                    margin: 0 10px;
                }
                .li:hover, .navLinks:hover {
                    cursor: pointer;
                    color: #84cef1;
                }
                .k-button {
                    padding: 0;
                }
                .k-badge-container {
                    margin-right: 8px;
                }
                .navLinks {
                    text-decoration: none;
                    color: #000000;
                }
            `}</style>
    </React.Fragment>
  );
}

export default Header;
